import { Controller } from "@hotwired/stimulus"

// Booking slot and duration selector for online reservations
export default class extends Controller {
  static targets = [
    "durationButton",
    "durationWarning",
    "slotButton", 
    "summary",
    "summaryTime",
    "summaryDuration",
    "formSlotTime",
    "formSunbedId",
    "formDuration",
    "confirmButton"
  ]

  connect() {
    this.selectedDuration = null
    this.selectedSlot = null
    this.selectedSunbedId = null
  }

  selectDuration(event) {
    const button = event.currentTarget
    
    // Deselect all duration buttons
    this.durationButtonTargets.forEach(btn => {
      btn.dataset.selected = "false"
    })
    
    // Select clicked button
    button.dataset.selected = "true"
    this.selectedDuration = button.dataset.duration
    
    // Hide warning when selecting a valid duration
    if (this.hasDurationWarningTarget) {
      this.durationWarningTarget.classList.add("hidden")
    }
    
    // Update form and summary
    this.formDurationTarget.value = this.selectedDuration
    this.summaryDurationTarget.textContent = `${this.selectedDuration} minutes`
    
    this.updateConfirmButton()
  }

  showDurationWarning(event) {
    const reason = event.currentTarget.dataset.reason
    if (this.hasDurationWarningTarget && reason) {
      this.durationWarningTarget.textContent = reason
      this.durationWarningTarget.classList.remove("hidden")
    }
  }

  selectSlot(event) {
    const button = event.currentTarget
    
    // Deselect all slot buttons
    this.slotButtonTargets.forEach(btn => {
      btn.dataset.selected = "false"
    })
    
    // Select clicked button
    button.dataset.selected = "true"
    this.selectedSlot = button.dataset.slotTime
    this.selectedSunbedId = button.dataset.sunbedId
    
    // Parse and format time
    const time = new Date(this.selectedSlot)
    const formattedTime = time.toLocaleTimeString("fr-FR", { 
      hour: "2-digit", 
      minute: "2-digit",
      timeZone: "Europe/Brussels"
    })
    
    // Update form and summary
    this.summaryTimeTarget.textContent = formattedTime
    this.formSlotTimeTarget.value = this.selectedSlot
    this.formSunbedIdTarget.value = this.selectedSunbedId
    
    this.updateConfirmButton()
  }

  updateConfirmButton() {
    if (this.selectedDuration && this.selectedSlot) {
      this.summaryTarget.classList.remove("hidden")
      this.confirmButtonTarget.disabled = false
    }
  }
}
